export enum MenuItemType {
  Menu = 'menu',
  Btn = 'btn',
  Route = 'route',
}

export type MenuItemTypeType = (typeof MenuItemType)[keyof typeof MenuItemType];

export interface MenuItem {
  key: string; // unique identifier (for permission judgment)
  name: string; // menu name
  path?: string; // route
  icon?: string; // icon
  type: MenuItemTypeType; // whether it's a menu item
  component?: string; // page component (full path)
  default?: string; // default route (for sub-menu)
  children?: MenuItem[]; // child items
  permissions?: string[]; // required permissions
  onlyShowParent?: boolean; // whether to show parent items only
}

export type MenuList = MenuItem[];

export interface RenderedMenuItem {
  key: string;
  type?: MenuItemTypeType;
  name: string;
  path?: string;
  icon?: React.ReactNode;
  component?: React.ReactNode;
  default?: string;
  parent?: string;
  menuPath?: string;
  children?: RenderedMenuItem[];
  onlyShowParent?: boolean;
}

export type SelectedMenus = {
  [key: string]: { [key: number]: RenderedMenuItem | undefined };
};
